module.exports = __webpack_public_path__ + "static/fonts/Roboto900.3234b3e8.ttf";